// SPDX-License-Identifier: AGPL-3.0-or-later

import { NavLink, Outlet } from 'react-router';
import { useMe } from '../../api/auth.js';

export function SettingsLayout() {
  const { data: me } = useMe();
  const isAdmin = me?.user.role === 'admin';

  return (
    <div
      style={{ maxWidth: 800, margin: '0 auto', padding: '24px var(--space-4)' }}
      className="space-y-8"
    >
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Manage your personal profile, application theme, and administrative clinic options.
        </p>
      </div>

      {/* Tabs navigation */}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          borderBottom: '1px solid rgb(var(--color-border))',
          paddingBottom: '8px',
          overflowX: 'auto',
        }}
      >
        <NavLink
          to="/settings"
          end
          style={({ isActive }) => ({
            padding: '8px 16px',
            fontSize: 'var(--text-sm)',
            fontWeight: 'var(--weight-semibold)',
            color: isActive ? 'rgb(var(--color-primary))' : 'rgb(var(--color-muted-foreground))',
            borderBottom: isActive
              ? '2px solid rgb(var(--color-primary))'
              : '2px solid transparent',
            textDecoration: 'none',
            marginBottom: '-9px',
            transition: 'all 0.2s ease',
          })}
          className="hover:text-foreground"
        >
          My Profile
        </NavLink>
        {isAdmin && (
          <>
            <NavLink
              to="/settings/organization"
              style={({ isActive }) => ({
                padding: '8px 16px',
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--weight-semibold)',
                color: isActive
                  ? 'rgb(var(--color-primary))'
                  : 'rgb(var(--color-muted-foreground))',
                borderBottom: isActive
                  ? '2px solid rgb(var(--color-primary))'
                  : '2px solid transparent',
                textDecoration: 'none',
                marginBottom: '-9px',
                transition: 'all 0.2s ease',
              })}
              className="hover:text-foreground"
            >
              Clinic Settings
            </NavLink>
            <NavLink
              to="/settings/team"
              style={({ isActive }) => ({
                padding: '8px 16px',
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--weight-semibold)',
                color: isActive
                  ? 'rgb(var(--color-primary))'
                  : 'rgb(var(--color-muted-foreground))',
                borderBottom: isActive
                  ? '2px solid rgb(var(--color-primary))'
                  : '2px solid transparent',
                textDecoration: 'none',
                marginBottom: '-9px',
                transition: 'all 0.2s ease',
              })}
              className="hover:text-foreground"
            >
              Team Management
            </NavLink>
            <NavLink
              to="/settings/design-system"
              style={({ isActive }) => ({
                padding: '8px 16px',
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--weight-semibold)',
                color: isActive
                  ? 'rgb(var(--color-primary))'
                  : 'rgb(var(--color-muted-foreground))',
                borderBottom: isActive
                  ? '2px solid rgb(var(--color-primary))'
                  : '2px solid transparent',
                textDecoration: 'none',
                marginBottom: '-9px',
                transition: 'all 0.2s ease',
              })}
              className="hover:text-foreground"
            >
              Design System
            </NavLink>
          </>
        )}
      </div>

      <div style={{ marginTop: '24px' }}>
        <Outlet />
      </div>
    </div>
  );
}
